export default {
  title: '{{company}} a mis à jour votre heure de retrait',
  title_on_site: "{{company}} a mis à jour l'heure de service de votre commande",
  new_time_label: 'Nouvelle heure',
};
